import { createSlice } from '@reduxjs/toolkit';

import { secureLubaApi } from 'services/secureLubaApi';
import { mixedAuthLubaApi } from 'services/mixedAuthLubaApi';
import { SESSION_STORAGE_KEYS } from './constants';

const initialState = {
  storedRole: sessionStorage.getItem(SESSION_STORAGE_KEYS.ACTIVE_ROLE) || null,
};

export const activeRoleSlice = createSlice({
  name: 'activeRole',
  initialState,
  reducers: {
    roleChanged: (state, action) => {
      state.storedRole = action.payload;
    },
  },
});

export const { roleChanged } = activeRoleSlice.actions;

export const switchActiveRole = (role) => (dispatch) => {
  sessionStorage.setItem(SESSION_STORAGE_KEYS.ACTIVE_ROLE, role);
  dispatch(roleChanged(role));
  // Changing the X-Active-Role header does not invalidate RTK Query caches by itself, so drop
  // every secure query. mixedAuthLubaApi also sends X-Active-Role now — this stored role itself,
  // when it is a GC role (Admins/GuestPermit), otherwise the best held GC role (mixedAuthLubaApi.js)
  // — so switching between two GC roles while already on /gc can change what it sends too, and its
  // cache needs dropping right along with secureLubaApi's.
  dispatch(secureLubaApi.util.resetApiState());
  dispatch(mixedAuthLubaApi.util.resetApiState());
};

export const selectStoredActiveRole = (state) => state.activeRole.storedRole;

export default activeRoleSlice.reducer;
